let fired = false;

export function consumeFlightHint(): boolean {
  if (fired) return false;
  fired = true;
  return true;
}
